import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FullPageError from '../../errorBoundary/FullPageError';
import { jsx as _jsx } from "react/jsx-runtime";
const loadReportPage = () => import( /* webpackChunkName: "report-page" */'crm-index-ui/app/components/ReportPage').then(mod => mod.default);
const LoadingComponent = () => /*#__PURE__*/_jsx(LoadingSpinner, {
  grow: true
});
const AsyncReportPage = Loadable({
  loader: loadReportPage,
  LoadingComponent,
  ErrorComponent: FullPageError
});
export default AsyncReportPage;